/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function InhibitionByCameraLoadedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeInhibitionByCameraLoadedAction } action:
 *     action de l'application
 * @return { Reducer }
 */
export const InhibitionByCameraLoadedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action: actionsTypesFromStore.TypeInhibitionByCameraLoadedAction) => {
          switch (action.type) {
            case actions.InhibitionByCameraLoadedActionTypes
                .INHIBITIONBYCAMERALOADED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;
            case actions.InhibitionByCameraLoadedActionTypes
                .INHIBITIONBYCAMERALOADED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.InhibitionByCameraLoadedActionTypes
                .INHIBITIONBYCAMERALOADED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            default:
              return state
              break;
          }
        }



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/supervision/inhibitions/camera/index.ts